//@flow

import React from "react";

import { PromiseWatcher } from "@/components";
import { PromiseError, PromiseState } from "@/components/PromiseWatcher/PromiseWatcher";
import { HubspotErrorResponse, HubspotResponse } from "@/utils";

type Props = {
    /**
     * A promise of the hubspot form request.
     */
    promise: Promise<HubspotResponse> | null,
    /**
     * The name of the field this message is for.
     */
    field: string,
};

const HubspotFormMessage = ({promise, field}: Props): React$Element<typeof PromiseWatcher> => {
    const renderMessage = (value: PromiseState<HubspotResponse>) => {
        if (
            value instanceof PromiseError &&
            value.error instanceof HubspotErrorResponse
        ) {
            const { error } = value;
            const errorForField = error.getError(field);
            if (errorForField !== null) {
                return (
                    <span className="text-danger fs-2 text-left d-block">
                        {errorForField.realMessage}
                    </span>
                );
            }
        }
        return null;
    };
    return (
        <PromiseWatcher promise={promise}>
            {value => renderMessage(value)}
        </PromiseWatcher>
    );
};

export default HubspotFormMessage;
